var lazy_css = [],
  lazy_js = [];
function _debounce(e, t = 300) {
  let a;
  return (...r) => {
    clearTimeout(a), (a = setTimeout(() => e.apply(this, r), t));
  };
}
(window.___mnag = 'userA' + (window.___mnag1 || '') + 'gent'),
  (window.___plt = 'plat' + (window.___mnag1 || '') + 'form');
try {
  var e = navigator[window.___mnag],
    t = navigator[window.___plt];
  (window.__isPSA = t.indexOf('x86_64') > -1 && 0 > e.indexOf('CrOS')),
    (window.___mnag = '!1'),
    (r = null);
} catch (a) {
  window.__isPSA = !1;
  var r = null;
  window.___mnag = '!1';
}
if (((window.__isPSA = __isPSA), __isPSA))
  var uLTS = new MutationObserver((e) => {
      e.forEach(({ addedNodes: e }) => {
        e.forEach((e) => {
          1 !== e.nodeType ||
            'IFRAME' !== e.tagName ||
            e.hasAttribute('data-prefetch-disabled') ||
            (e.setAttribute('loading', 'lazy'),
            e.setAttribute('data-src', e.src),
            e.removeAttribute('src')),
            1 === e.nodeType &&
              'IMG' === e.tagName &&
              !e.hasAttribute('loading') &&
              ++imageCount > lazyImages &&
              e.setAttribute('loading', 'lazy'),
            1 === e.nodeType &&
              'LINK' === e.tagName &&
              lazy_css.length &&
              lazy_css.forEach((t) => {
                e.href.includes(t) &&
                  (e.setAttribute('data-href', e.href),
                  e.removeAttribute('href'));
              }),
            1 === e.nodeType &&
              'SCRIPT' === e.tagName &&
              (e.setAttribute('data-src', e.src),
              e.removeAttribute('src'),
              (e.type = 'text/lazyload'));
        });
      });
    }),
    imageCount = 0,
    lazyImages = 20;
else
  (uLTS = new MutationObserver((e) => {
    e.forEach(({ addedNodes: e }) => {
      e.forEach((e) => {
        1 !== e.nodeType ||
          'IFRAME' !== e.tagName ||
          e.hasAttribute('data-prefetch-disabled') ||
          (e.setAttribute('loading', 'lazy'),
          e.setAttribute('data-src', e.src),
          e.removeAttribute('src')),
          1 === e.nodeType &&
            'IMG' === e.tagName &&
            !e.hasAttribute('loading') &&
            ++imageCount > lazyImages &&
            e.setAttribute('loading', 'lazy'),
          1 === e.nodeType &&
            'LINK' === e.tagName &&
            lazy_css.length &&
            lazy_css.forEach((t) => {
              e.href.includes(t) &&
                (e.setAttribute('data-href', e.href),
                e.removeAttribute('href'));
            }),
          1 === e.nodeType &&
            'SCRIPT' === e.tagName &&
            (lazy_js.length &&
              lazy_js.forEach((t) => {
                e.src.includes(t) &&
                  (e.setAttribute('data-src', e.src), e.removeAttribute('src'));
              }),
            e.innerHTML.includes('asyncLoad') &&
              (e.innerHTML = e.innerHTML
                .replace(
                  'if(window.attachEvent)',
                  "document.addEventListener('asyncLazyLoad',function(event){asyncLoad();});if(window.attachEvent)",
                )
                .replaceAll(', asyncLoad', ', function(){}')),
            (e.innerHTML.includes('PreviewBarInjector') ||
              e.innerHTML.includes('adminBarInjector')) &&
              (e.innerHTML = e.innerHTML.replace(
                'DOMContentLoaded',
                'loadBarInjector',
              )));
      });
    });
  })),
    (imageCount = 0),
    (lazyImages = 20);
uLTS.observe(document.documentElement, { childList: !0, subtree: !0 });
